import React, { PropsWithChildren } from 'react';
import { IconClear } from '@yoti/ui-kit-components-react/globals';

import styles from './response.module.scss';
import classNames from 'classnames';

interface ResponseProps {
    errorCode?: string;
    errorMessage?: string;
    'data-qa'?: string;
}

const Response = ({
    errorCode,
    errorMessage,
    children,
    'data-qa': dataQa = 'response',
}: PropsWithChildren<ResponseProps>) => {
    return (
        <div className={styles['response']} data-qa={dataQa}>
            <div>
                {errorCode ? (
                    <div
                        className={classNames(
                            styles['response__container'],
                            styles['response__element'],
                        )}
                        data-qa={'error-result'}
                    >
                        <IconClear className={styles['response__element__icon-error']} />
                        <span>{errorMessage}</span>
                    </div>
                ) : (
                    <div className={styles['response__container']}>
                        {children &&
                            React.Children.map(
                                children,
                                (r, i) =>
                                    !!r && (
                                        <div
                                            className={styles['response__element']}
                                            data-qa={'children'}
                                            key={i}
                                        >
                                            {r}
                                        </div>
                                    ),
                            )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Response;
